import React from 'react';
import { useParams } from 'react-router-dom';

const DocumentPage: React.FC = () => {
  const { sessionKey, documentId } = useParams();

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">
          Belge Detayları
        </h1>
        <div className="bg-white rounded-lg shadow-sm border p-6">
          <p className="text-gray-600">
            Session: {sessionKey}
          </p>
          <p className="text-gray-600">
            Document: {documentId}
          </p>
          <p className="text-sm text-gray-500 mt-4">
            Bu sayfa yakında tamamlanacak.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DocumentPage;